import React from 'react';
import Footer from "../components/Footer";
import Hero from "../components/Hero";

function TermsView() {
    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <Hero/>
                <h2 className="text-2xl font-bold text-center text-gray-900 mb-12">Polityka prywatności</h2>
                <div>
                    I. Postanowienia ogólne
                    1. Polityka prywatności określa, jak zbierane, przetwarzane i przechowywane są dane
                    osobowe Użytkowników niezbędne do świadczenia usług drogą elektroniczną za
                    pośrednictwem serwisu internetowego kiedysmieci.pl (dalej: Serwis).
                    2. Serwis zbiera wyłącznie dane osobowe niezbędne do świadczenia i rozwoju usług w
                    nim oferowanych.
                    3. Dane osobowe zbierane za pośrednictwem Serwisu są przetwarzane zgodnie
                    z Rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27
                    kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem
                    danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia
                    dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych, dalej RODO) oraz
                    ustawą o ochronie danych osobowych z dnia 10 maja 2018 r.
                    II. Administrator danych
                    Administratorem danych osobowych zbieranych poprzez Serwis jest Jakub Such Consulting,
                    adres: Potok Stany Kolonia 48, 23-313 Potok Wielki, NIP: 8621633929, REGON:
                    362204535, formularz kontaktowy: kiedysmieci.pl/kontakt (dalej: Administrator).
                    III. Cel zbierania danych osobowych
                    1. Dane osobowe wykorzystywane są w celu:
                    o rejestracji konta i weryfikacji tożsamości Użytkownika,
                    o umożliwienia logowania do Serwisu,
                    o realizacji umowy dotyczącej usług i e-usług,
                    o komunikacji z Użytkownikiem (livechat, formularz kontaktowy itp.)
                    o wysyłki newslettera (po wyrażeniu zgody Użytkownika na jego
                    otrzymywanie),
                    o prowadzenia systemu komentarzy,
                    o świadczenia usług społecznościowych,
                    o promocji oferty Administratora,
                    o marketingu, remarketingu, afiliacji,
                    o personalizacji Serwisu dla Użytkowników,
                    o działań analitycznych i statystycznych,
                    o windykacji należności,
                    o ustalenia i dochodzenia roszczeń albo obrony przed nimi.
                    2. Podanie danych jest dobrowolne, ale niezbędne do zawarcia umowy albo skorzystania
                    z innych funkcjonalności Serwisu.
                    IV. Rodzaj przetwarzanych danych osobowych
                    Administrator może przetwarzać dane osobowe Użytkownika: imię i nazwisko, data
                    urodzenia, adres zamieszkania, adres e-mail, numer telefonu, NIP.
                    V. Okres przetwarzania danych osobowych
                    Dane osobowe Użytkowników będą przetwarzane przez okres:
                    • gdy podstawą przetwarzania danych jest wykonanie umowy – do momentu
                    przedawnienia roszczeń po jej wykonaniu,
                    • gdy podstawą przetwarzania danych jest zgoda – do momentu jej odwołania, a po
                    odwołaniu zgody do przedawnienia roszczeń.
                    W obu przypadkach termin przedawnienia wynosi 6 lat, a dla roszczeń o świadczenia
                    okresowe i roszczeń dotyczących prowadzenia działalności gospodarczej – 3 lata (jeśli
                    przepis szczególny nie stanowi inaczej).
                    VI. Udostępnianie danych osobowych
                    1. Dane osobowe Użytkowników mogą być przekazywane: podmiotom powiązanym z
                    Administratorem, jego podwykonawcom, podmiotom współpracującym z
                    Administratorem np. firmom obsługującym e-płatności, firmom świadczącym usługi
                    kurierskie/pocztowe, kancelariom prawnym.
                    2. Dane osobowe Użytkowników będą przekazywane poza teren Europejskiego Obszaru
                    Gospodarczego (EOG).
                    VII. Prawa Użytkowników
                    1. Użytkownik Serwisu ma prawo do: dostępu do treści swoich danych osobowych, ich
                    sprostowania, usunięcia, ograniczenia przetwarzania, przenoszenia, wniesienia
                    sprzeciwu wobec przetwarzania, cofnięcia zgody w każdej chwili (co nie ma wpływu
                    na zgodność z prawem przetwarzania dokonanego w oparciu o zgodę przed jej
                    cofnięciem).
                    2. Zgłoszenie o wystąpieniu przez Użytkownika z uprawnieniem wynikającym
                    z wymienionych praw należy przesłać poprzez formularz kontaktowy umieszczony na kiedysmieci.pl/kontakt .
                    3. Administrator spełnia lub odmawia spełnienia żądania niezwłocznie – maksymalnie w
                    ciągu miesiąca od jego otrzymania.
                    4. Użytkownik ma prawo złożyć skargę do Prezesa Urzędu Ochrony Danych
                    Osobowych, jeśli uzna, że przetwarzanie narusza jego prawa i wolności (RODO).
                    VIII. Pliki cookies
                    1. Serwis zbiera informacje za pomocą plików cookies – sesyjnych, stałych i podmiotów
                    zewnętrznych.
                    2. Zbieranie plików cookies wspiera poprawne świadczenie usług w Serwisie i służy
                    celom statystycznym.
                    3. Użytkownik może określić zakres dostępu plików cookies do swojego urządzenia w
                    ustawieniach przeglądarki.
                    IX. Zautomatyzowane podejmowanie decyzji i profilowanie
                    1. Dane Użytkowników nie mogą być przetwarzane w zautomatyzowany sposób tak, że
                    na skutek tego mogłyby zapaść wobec nich jakiekolwiek decyzje.
                    2. Dane Użytkowników mogą być profilowane celem dostosowania treści i
                    personalizacji oferty po wyrażeniu przez nich zgody.
                    X. Postanowienia końcowe
                    1. Administrator ma prawo do wprowadzenia zmian w Polityce prywatności, przy czym
                    prawa Użytkowników nie zostaną ograniczone.
                    2. Informacja o wprowadzonych zmianach pojawi się w formie komunikatu dostępnego
                    w Serwisie.
                    3. W sprawach nieuregulowanych w niniejszej Polityce prywatności obowiązują
                    przepisy RODO i przepisy prawa polskiego.
                </div>
                <h2 className="text-2xl font-bold text-center text-gray-900 mb-12">
                    Regulamin
                </h2>
                <div>
                    Regulamin serwisu
                    1. Serwis kiedysmieci.pl, dostępny pod adresem internetowym https://kiedysmieci.pl,
                    prowadzony jest przez Jakub Such prowadzącego działalność gospodarczą pod firmą Jakub
                    Such Consulting, wpisaną do Centralnej Ewidencji i Informacji o Działalności Gospodarczej
                    (CEIDG) prowadzonej przez ministra właściwego ds. gospodarki, NIP 8621633929, REGON
                    362204535.
                    2. Osoby korzystające oraz powierzające dane serwisowi wyrażają równocześnie zgodę na:
                    a) wykonywania w ich imieniu zapytań do stron i firm posiadających harmonogramy wywozu
                    odpadów
                    b) otrzymywanie komunikacji mailowej z informacjami o harmonogramie wywozu odpadów komunalnych
                    c) otrzymywanie komunikacji mailowej z informacjami o ofertach handlowych (np. reklamach)
                    partnerów kiedysmieci.pl
                    d) przetwarzania powierzonych danych w celu wykonania usługi powiadomień
                    3. Osoba w kazdej chwili moze zerzygnowac z otrzymywania komunikacji mailowej oraz ma prawo
                    usuniecia danych rejestracyjnych z systemu kiedysmieci.pl
                    4.Właściciel serwisu zastrzega sobie prawo do dokonywania zmian Regulaminu z ważnych
                    przyczyn.
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default TermsView;
